var path = '/Users/jakebuszynski/Documents/git/gitlab/enplug-projects/enplug.com/src/templates/not.found.tpl.html';
var html = "<h1>Not Found - 404</h1> <h3> {{ message }} </h3> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/templates/not.found.tpl.html
// module id = 102
// module chunks = 0